import { createStore as V, combineReducers as k } from "redux";
import { inject as S, provide as v, reactive as $, onUnmounted as C, ref as T } from "vue";
const y = "$ReduxVuexStoreToken$", b = "$ReduxVuexActionsToken$", _ = (e, r) => {
  if (!e)
    throw new Error("[redux-vuex]: store is not defined");
  r ? r.provide(y, e) : v(y, e);
}, h = (e, r) => {
  e && (r ? r.provide(b, e) : v(b, e));
}, x = () => {
  const e = S(y);
  return e || (console.warn("[redux-vuex]: couldn't find a store, make sure you have provided it"), V(k({})));
}, E = () => S(b, {});
function G(e) {
  _(e.store, e.app), h(e.actions, e.app);
}
function M(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */
var R = function(r) {
  return r != null && typeof r == "object" && Array.isArray(r) === !1;
};
/*!
 * get-value <https://github.com/jonschlinkert/get-value>
 *
 * Copyright (c) 2014-2018, Jon Schlinkert.
 * Released under the MIT License.
 */
const O = R;
var P = function(e, r, n) {
  if (O(n) || (n = { default: n }), !A(e))
    return typeof n.default < "u" ? n.default : e;
  typeof r == "number" && (r = String(r));
  const t = Array.isArray(r), u = typeof r == "string", d = n.separator || ".", f = n.joinChar || (typeof d == "string" ? d : ".");
  if (!u && !t)
    return e;
  if (u && r in e)
    return a(r, e, n) ? e[r] : n.default;
  let i = t ? r : g(r, d, n), o = i.length, s = 0;
  do {
    let c = i[s];
    for (typeof c == "number" && (c = String(c)); c && c.slice(-1) === "\\"; )
      c = p([c.slice(0, -1), i[++s] || ""], f, n);
    if (c in e) {
      if (!a(c, e, n))
        return n.default;
      e = e[c];
    } else {
      let m = !1, l = s + 1;
      for (; l < o; )
        if (c = p([c, i[l++]], f, n), m = c in e) {
          if (!a(c, e, n))
            return n.default;
          e = e[c], s = l - 1;
          break;
        }
      if (!m)
        return n.default;
    }
  } while (++s < o && A(e));
  return s === o ? e : n.default;
};
function p(e, r, n) {
  return typeof n.join == "function" ? n.join(e) : e[0] + r + e[1];
}
function g(e, r, n) {
  return typeof n.split == "function" ? n.split(e) : e.split(r);
}
function a(e, r, n) {
  return typeof n.isValid == "function" ? n.isValid(e, r) : !0;
}
function A(e) {
  return O(e) || Array.isArray(e) || typeof e == "function";
}
const B = /* @__PURE__ */ M(P), w = (e) => {
  const [r] = e;
  if (!Array.isArray(r) && typeof r == "object")
    return Object.keys(r).reduce((t, u) => {
      const d = r[u];
      return {
        ...t,
        [u]: d
      };
    }, {});
  const n = e;
  return [].concat.apply([], n).reduce(
    (t, u) => ({
      ...t,
      [u]: u
    }),
    {}
  );
}, j = (e, r) => Object.entries(e).reduce((n, [t, u]) => ({
  ...n,
  [t]: r(t, u)
}), {});
function U(...e) {
  const r = (o) => (s) => B(s, o), n = x(), t = w(e), u = j(
    t,
    (o, s) => typeof s == "string" ? r(s) : s
  ), d = $(j(t, (o) => T(o))), f = () => {
    Object.keys(t).forEach((o) => {
      d[o] = u[o].call(null, n.getState());
    });
  };
  f();
  const i = n.subscribe(f);
  return C(i), d;
}
function q(...e) {
  const r = x(), n = E(), t = (f) => {
    const i = n[f];
    if (!i) {
      console.warn(`[redux-vuex] action ${f} is not defined`);
      return;
    }
    return (...o) => r.dispatch(i(...o));
  }, u = (f) => (...i) => {
    f.apply(null, [Object.assign({}, r, { actions: n }), ...i]);
  }, d = w(e);
  return j(
    d,
    (f, i) => typeof i == "string" ? t(i) : u(i)
  );
}
export {
  b as actionsToken,
  E as injectActions,
  x as injectStore,
  q as mapActions,
  U as mapState,
  G as provideStore,
  y as storeToken
};
